var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":"lg"}},[_c('div',{staticClass:"main-container"},[(_vm.gameType === 'TEREM')?_c('TeremTimeline',{attrs:{"items":_vm.items,"gameType":_vm.gameType}}):_vm._e(),(_vm.gameType === 'STRAND')?_c('StrandTimeline',{attrs:{"items":_vm.items,"gameType":_vm.gameType}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }